// APIから受け取った問題一覧を画面のパート単位へ振り分ける
export const splitQuestionParts = (questions) => {
  const questionList = Array.isArray(questions) ? questions : [];

  return {
    part1: questionList.filter((question) => question.questionPart === 1),
    part2: questionList.filter((question) => question.questionPart === 2),
    part3: questionList.filter((question) => question.questionPart === 3),
  };
};
